<template>
  <vs-popup
    class="apple-modal modal-regra-pos-venda"
    :title="isEdit ? 'Editar Regra de Pós-Venda' : 'Nova Regra de Pós-Venda'"
    :active.sync="activeLocal"
    @close="fechar"
  >
    <div class="apple-modal-body">
      <!-- Callout Apple -->
      <div class="apple-callout mb-4">
        <feather-icon icon="InfoIcon" svgClasses="w-4 h-4 text-blue-600 mr-2.5 flex-shrink-0" />
        <p class="apple-callout-text">
          O WATI disparará o template selecionado após decorridos os <strong>dias configurados</strong> da conclusão da <strong>ordem de serviço</strong> do cliente.
        </p>
      </div>

      <div class="apple-form-grid">
        <!-- Nome da Regra -->
        <div class="apple-form-group col-span-12">
          <label class="apple-label">Nome / Identificação da Regra <span class="text-rose-500">*</span></label>
          <input
            v-model="form.nome"
            type="text"
            class="apple-native-input"
            placeholder="Ex: Pesquisa de Satisfação - 5ª OS do Cliente"
          />
        </div>

        <!-- Sequência da OS -->
        <div class="apple-form-group col-span-6">
          <label class="apple-label">Sequência da OS no Cliente</label>
          <el-select
            v-model="form.sequencia_os"
            class="w-full apple-el-select"
            size="small"
            clearable
            popper-class="regua-el-popper"
            placeholder="Qualquer OS (Todas)"
          >
            <el-option :value="null" label="Qualquer OS (Todas)" />
            <el-option :value="1" label="1ª OS (Primeiro Serviço)" />
            <el-option :value="2" label="2ª OS (Segundo Serviço)" />
            <el-option :value="3" label="3ª OS (Terceiro Serviço)" />
            <el-option :value="4" label="4ª OS (Quarto Serviço)" />
            <el-option :value="5" label="5ª OS (Quinto Serviço)" />
            <el-option :value="6" label="6ª OS (Sexto Serviço)" />
            <el-option :value="7" label="7ª OS (Sétimo Serviço)" />
            <el-option :value="8" label="8ª OS (Oitavo Serviço)" />
            <el-option :value="9" label="9ª OS (Nono Serviço)" />
            <el-option :value="10" label="10ª OS (Décimo Serviço)" />
            <el-option :value="15" label="15ª OS (15º Serviço)" />
            <el-option :value="20" label="20ª OS (20º Serviço)" />
          </el-select>
          <span class="apple-helper-text">Deixe em <strong>'Qualquer OS (Todas)'</strong> para enviar a todas as OSs concluídas, ou escolha (ex: 5ª OS) para disparar apenas quando o cliente atingir aquele número de serviço.</span>
        </div>

        <!-- Dias após execução -->
        <div class="apple-form-group col-span-6">
          <label class="apple-label">Dias após Execução <span class="text-rose-500">*</span></label>
          <input
            v-model="form.dias_apos_execucao"
            type="number"
            min="0"
            class="apple-native-input"
            placeholder="Ex: 5"
          />
          <span class="apple-helper-text">Dias de espera após a conclusão</span>
        </div>

        <!-- Template WATI -->
        <div class="apple-form-group col-span-12">
          <div class="apple-form-header-row">
            <label class="apple-label m-0">Template do WATI <span class="text-rose-500">*</span></label>
            <div class="apple-form-header-actions">
              <button
                type="button"
                class="apple-link-action"
                :disabled="loadingTemplates"
                @click="$emit('sincronizar-templates')"
                title="Sincronizar templates do WATI agora"
              >
                <feather-icon icon="RefreshCwIcon" svgClasses="w-3 h-3 mr-1 inline" :class="{ 'animate-spin': loadingTemplates }" />
                <span>Atualizar Lista</span>
              </button>
              <span class="action-separator">·</span>
              <router-link to="/parametro" target="_blank" class="apple-link-action">
                Configurações WATI
              </router-link>
            </div>
          </div>
          <el-select
            v-model="form.template_nome"
            class="w-full apple-el-select"
            size="small"
            filterable
            popper-class="regua-el-popper"
            placeholder="Selecione o template WATI aprovado"
            :loading="loadingTemplates"
          >
            <el-option
              v-for="tpl in templates"
              :key="tpl.templateName || tpl.elementName || tpl.name"
              :value="tpl.templateName || tpl.elementName || tpl.name"
              :label="(tpl.templateName || tpl.elementName || tpl.name) + (tpl.category ? ' (' + tpl.category + ')' : '')"
            />
          </el-select>
        </div>

        <!-- Equipes Opcional -->
        <div class="apple-form-group col-span-12">
          <label class="apple-label">Direcionar para Equipe WATI <span class="text-gray-400 font-normal">(Opcional)</span></label>
          <input
            v-model="form.equipes"
            type="text"
            class="apple-native-input"
            placeholder="Ex: PosVenda, Atendimento (separadas por vírgula)"
          />
        </div>

        <!-- Switch Ativo / Inativo Apple -->
        <div class="col-span-12 apple-switch-card">
          <div>
            <div class="text-sm font-semibold text-gray-900">Status da Regra</div>
            <div class="text-xs text-gray-500 mt-0.5">Regras ativas disparam mensagens automaticamente</div>
          </div>
          <vs-switch v-model="form.ativo" color="success" />
        </div>
      </div>

      <!-- Rodapé Apple -->
      <div class="apple-dialog-footer">
        <button type="button" class="apple-dialog-btn apple-btn-cancel" @click="fechar">
          Cancelar
        </button>
        <button type="button" class="apple-dialog-btn apple-btn-save" :disabled="salvando" @click="salvar">
          {{ salvando ? 'Salvando...' : (isEdit ? 'Salvar Alterações' : 'Criar Regra') }}
        </button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: "ModalRegraPosVenda",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    regra: {
      type: Object,
      default: null
    },
    templates: {
      type: Array,
      default: function () {
        return [];
      }
    },
    loadingTemplates: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeLocal: false,
      salvando: false,
      form: {
        id: null,
        tipo: 'pos_venda',
        nome: '',
        sequencia_os: null,
        dias_apos_execucao: 5,
        template_nome: '',
        template_id: null,
        equipes: '',
        ativo: true
      }
    };
  },
  computed: {
    isEdit() {
      return !!(this.form && this.form.id);
    }
  },
  watch: {
    active(val) {
      this.activeLocal = val;
      if (val) {
        this.popularForm();
      }
    },
    activeLocal(val) {
      this.$emit('update:active', val);
    }
  },
  methods: {
    popularForm() {
      if (this.regra && this.regra.id) {
        this.form = {
          id: this.regra.id,
          tipo: 'pos_venda',
          nome: this.regra.nome || '',
          sequencia_os: this.regra.sequencia_os ? Number(this.regra.sequencia_os) : null,
          dias_apos_execucao: this.regra.dias_apos_execucao !== null && this.regra.dias_apos_execucao !== undefined ? Number(this.regra.dias_apos_execucao) : 5,
          template_nome: this.regra.template_nome || '',
          template_id: this.regra.template_id || null,
          equipes: this.regra.equipes || '',
          ativo: this.regra.ativo !== undefined ? Boolean(this.regra.ativo) : true
        };
      } else {
        this.form = {
          id: null,
          tipo: 'pos_venda',
          nome: '',
          sequencia_os: null,
          dias_apos_execucao: 5,
          template_nome: '',
          template_id: null,
          equipes: '',
          ativo: true
        };
      }
    },
    fechar() {
      this.activeLocal = false;
      this.$emit('update:active', false);
    },
    async salvar() {
      if (!this.form.nome || !this.form.nome.trim()) {
        this.$vs.notify({
          title: "Atenção",
          text: "Informe o nome da regra.",
          color: "warning"
        });
        return;
      }
      if (!this.form.template_nome) {
        this.$vs.notify({
          title: "Atenção",
          text: "Selecione o template WATI para a mensagem.",
          color: "warning"
        });
        return;
      }
      if (this.form.dias_apos_execucao === null || this.form.dias_apos_execucao === undefined || this.form.dias_apos_execucao === '') {
        this.$vs.notify({
          title: "Atenção",
          text: "Informe a quantidade de dias após a execução.",
          color: "warning"
        });
        return;
      }

      this.salvando = true;
      try {
        let res;
        const payload = {
          tipo: 'pos_venda',
          nome: this.form.nome,
          sequencia_os: this.form.sequencia_os ? Number(this.form.sequencia_os) : null,
          dias_apos_execucao: Number(this.form.dias_apos_execucao),
          template_nome: this.form.template_nome,
          template_id: this.form.template_id,
          equipes: this.form.equipes,
          ativo: Boolean(this.form.ativo)
        };

        if (this.isEdit) {
          res = await this.$http.put(`regua-disparos/${this.form.id}`, payload);
        } else {
          res = await this.$http.post('regua-disparos', payload);
        }

        this.$vs.notify({
          title: "Sucesso",
          text: this.isEdit ? "Regra atualizada com sucesso!" : "Regra criada com sucesso!",
          color: "success"
        });

        this.$emit('salvo', res);
        this.fechar();
      } catch (err) {
        const error = this.$httpErrors ? this.$httpErrors(err) : { text: err.message };
        this.$vs.notify({
          title: "Erro ao salvar",
          text: error.text || err.message,
          color: "danger"
        });
      } finally {
        this.salvando = false;
      }
    }
  }
};
</script>

<style scoped>
/* =========================================================
   Modal Dialog Styling (Padrão Apple / SCORPIO ERP)
========================================================= */
.modal-regra-pos-venda >>> .vs-popup {
  max-width: 680px;
  width: 95%;
  border-radius: 16px;
}

.apple-modal-body {
  padding: 12px 16px 8px;
}

/* Callout */
.apple-callout {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #0284c7;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
}

.apple-callout-text {
  font-size: 12.5px;
  color: #334155;
  line-height: 1.45;
  margin: 0;
}

/* Form Layout */
.apple-form-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 18px;
}

.col-span-12 {
  grid-column: span 12 / span 12;
}

.col-span-6 {
  grid-column: span 6 / span 6;
}

@media (max-width: 640px) {
  .col-span-6 {
    grid-column: span 12 / span 12;
  }
}

.apple-form-group {
  display: flex;
  flex-direction: column;
}

.apple-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 6px;
}

.apple-native-input {
  width: 100%;
  height: 40px;
  border-radius: 9px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  padding: 0 14px;
  font-size: 13px;
  color: #0f172a;
  outline: none;
  transition: all 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}

.apple-native-input:focus {
  border-color: #0284c7;
  box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.15);
}

.apple-native-input::placeholder {
  color: #94a3b8;
}

.apple-helper-text {
  font-size: 11.5px;
  color: #64748b;
  margin-top: 5px;
}

.apple-form-header-row {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  width: 100% !important;
  margin-bottom: 6px !important;
}

.apple-form-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.apple-link-action {
  background: none;
  border: none;
  color: #0284c7;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  transition: color 0.15s ease;
}

.apple-link-action:hover {
  text-decoration: underline;
  color: #0369a1;
}

.action-separator {
  color: #cbd5e1;
  font-size: 12px;
}

/* Switch Card */
.apple-switch-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 18px;
}

/* Rodapé */
.apple-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 26px;
  padding-top: 18px;
  border-top: 1px solid #f1f5f9;
}

.apple-dialog-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  border-radius: 9px;
  padding: 0 20px;
  height: 38px;
  cursor: pointer;
  transition: all 0.18s cubic-bezier(0.16, 1, 0.3, 1);
  border: none;
  outline: none;
}

.apple-btn-save {
  background: linear-gradient(180deg, #0284c7 0%, #0369a1 100%);
  color: #ffffff;
  box-shadow: 0 2px 5px rgba(2, 132, 199, 0.25);
}

.apple-btn-save:hover {
  background: linear-gradient(180deg, #0369a1 0%, #075985 100%);
  box-shadow: 0 4px 10px rgba(2, 132, 199, 0.32);
  transform: translateY(-1px);
}

.apple-btn-cancel {
  background: #ffffff;
  color: #475569;
  border: 1px solid #cbd5e1;
}

.apple-btn-cancel:hover {
  background: #f8fafc;
  color: #0f172a;
  border-color: #94a3b8;
}
</style>

<style>
.regua-el-popper {
  z-index: 999999 !important;
}
</style>
